<template>
    <div>
        <v-alert :value="requestFailed" type="error" outline class="mt-4">
            <span>{{requestErrorMessage}}</span>
        </v-alert>
        <v-card-title primary-title>
            <div>
                <div class="headline">Import WCA Results</div>
            </div>
        </v-card-title>
        <v-card-text>
            <loading v-if="submitting" loadingMessage="Starting job..."></loading>
            <template v-else>
                <v-stepper v-model="importStep" vertical v-if="!processing">
                    <v-stepper-step :complete="importStep > 1" step="1">
                        Upload results
                        <small>Select an Excel Spreadsheet (.xlsx) file to import.</small>
                    </v-stepper-step>

                    <v-stepper-content step="1">
<!--                        <v-card class="mb-2">-->
                            <v-layout row wrap align-center>
                                <v-flex xs12 sm6>
                                    <div class="subheading">Import Template</div>
                                    <table class="import-template">
                                        <thead>
                                            <tr>
                                                <th>Key</th>
                                                <th>Result</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>WC19-24069356035067</td>
                                                <td>No Award</td>
                                            </tr>
                                            <tr>
                                                <td>WC19-35685724097265</td>
                                                <td>Bronze</td>
                                            </tr>
                                            <tr>
                                                <td>WC19-34603856735745</td>
                                                <td>Silver</td>
                                            </tr>
                                            <tr>
                                                <td>WC19-84676578956789</td>
                                                <td>Gold</td>
                                            </tr>
                                            <tr>
                                                <td>WC19-24924689376355</td>
                                                <td>Super Gold</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <input
                                            ref="targetFile"
                                            type="file"
                                            required
                                            @change="processFile"
                                    />
                                    <v-btn color="primary" :disabled="!fileSelected" @click="uploadImport" block class="mt-3">Upload</v-btn>
                                </v-flex>
                            </v-layout>
<!--                        </v-card>-->

                    </v-stepper-content>

                    <v-stepper-step :complete="importStep > 2" step="2">
                        Confirm Import
                    </v-stepper-step>

                    <v-stepper-content step="2">
                        <h2>Are you sure you want to run this import?</h2>
                        <p>Doing so will overwrite any existing results data, mark the entries as reviewed, and publish the
                            results. <strong>This cannot be undone.</strong></p>
                        <v-btn color="primary" :disabled="!fileSelected || !valid" @click="submitImport">Start WCA Results Import
                        </v-btn>
                    </v-stepper-content>
                </v-stepper>
                <loading v-else></loading>
            </template>
        </v-card-text>
        <cancel-form-warning @abort="resetWaring" @confirm="cancel" :warnDialog="warnDialog"></cancel-form-warning>
    </div>
</template>

<script>
  import CancelFormWarning from '@/views/app/elements/CancelFormWarning'
  import {CrudFormMixin} from '@/views/app/company/crud/crud-mixins'

  export default {
    name: 'dataops-imports-wc-results',
    mixins: [CrudFormMixin],
    components: {
      CancelFormWarning
    },
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      importStep: 1,
      processing: false,
      processingMessage: '',
      errors: null,
      jobConfig: {
        handler: 'imports.award_results_wc',
        params: {
          importFileName: null
        }
      },
      valid: true,
      uploadValid: false,
      uploadRules: [
        v => !!v || 'File name is required',
        v => (v && /^.{3,145}\.xlsx$/.test(v)) || 'File name must be at most 150 characters, and end in ".xlsx"'
      ],
      targetFilePath: null,
      fileSelected: false,
      fileToUpload: null
    }),
    created () {
    },
    computed: {
      apiPath () {
        return '/admin/dataops'
      }
    },
    methods: {
      processFile (event) {
        console.log(event)
        if (event.target.files[0]) {
          this.fileToUpload = event.target.files[0]
          this.fileSelected = true
        } else {
          this.fileToUpload = null
          this.fileSelected = false
        }
      },
      uploadImport () {
        const self = this
        const file = self.fileToUpload
        const userUID = self.firebaseUser.uid
        // Create a reference where we can upload the file
        // const uploadRef = self.$firebaseClient.firebaseStorageRef.child('imports').child('categories').child(userUID).child(file.name)
        const targetPath = `gs://${self.$firebaseClient.firebaseInstance.options.projectId}/imports/results/${userUID}/${file.name}`
        const uploadRef = self.$firebaseClient.firebaseInstance.storage().refFromURL(targetPath)
        // Start the upload
        const uploadTask = uploadRef.put(file)
        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on('state_changed',
          (snapshot) => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            console.log(`Upload is ${progress}% done`)
            switch (snapshot.state) {
              case 'paused':
                console.log('Upload is paused')
                break
              case 'running':
                console.log('Upload is running')
                break
              default:
                console.log(`Upload is ${snapshot.state}`)
            }
          }, (error) => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break
              case 'storage/canceled':
                // User canceled the upload
                break
              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break
              default:
                console.log(`Upload error ${error.code}`)
            }
          }, () => {
            // Upload succeeded; save file name and move to next step
            self.jobConfig.params.importFileName = file.name
            console.log('[WC RESULTS IMPORT]: Upload Complete')
            self.importStep = 2
          }
        )
      },
      submitImport () {
        const self = this
        self.formSubmitted(self.jobConfig)
      },
      handleSuccess(response) {
        const self = this
        self.$notifications.$emit('toast', {text: 'Successfully submitted job!', colour: 'success', buttonColour: ''})
        console.log(`[${self.formName}]: Successfully submitted: ${response}`)
        self.$router.push({name: 'dataops.jobs.read', params: {jobUID: response.jobUID}})
        self.submitting = false
      }
    }
  }
</script>

<style lang="scss">
    .import-template {
        text-align: left;
        border: 1px solid grey;
        border-collapse: collapse;
        td, th {
            border: 1px solid grey;
            padding: 5px;
        }
    }
</style>
